module.exports = __webpack_public_path__ + "static/img/23.6c59041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/23.png
// module id = Qagx
// module chunks = 10